import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMastercard = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 60,
	height: 42,
	viewBox: "0 0 60 42",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_dd)",
			children: /* @__PURE__ */ _jsx("rect", {
				x: 6,
				y: 3,
				width: 48,
				height: 30,
				rx: 2,
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 37,
			cy: 18,
			r: 10,
			fill: "#F79E1B"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 23,
			cy: 18,
			r: 10,
			fill: "#EB001B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30 25.1415C31.8514 23.3266 33 20.7975 33 18.0001C33 15.2027 31.8514 12.6736 30 10.8586C28.1486 12.6736 27 15.2027 27 18.0001C27 20.7975 28.1486 23.3266 30 25.1415Z",
			fill: "#FF5F00"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
			id: "filter0_dd",
			x: 0,
			y: 0,
			width: 60,
			height: 42,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 3 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 3 }),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
				}),
				/* @__PURE__ */ _jsx("feMorphology", {
					radius: 1,
					operator: "dilate",
					in: "SourceAlpha",
					result: "effect2_dropShadow"
				}),
				/* @__PURE__ */ _jsx("feOffset", {}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "effect1_dropShadow",
					result: "effect2_dropShadow"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect2_dropShadow",
					result: "shape"
				})
			]
		}) })
	]
});
const ForwardRef = forwardRef(SvgMastercard);
export { ForwardRef as ReactComponent };
